export const parseRpDetailsValue = (storedValue) => {
  const decodedString = decodeURIComponent(storedValue);
  const normalizedString = decodedString.startsWith("c{")
    ? decodedString.slice(1)
    : decodedString;

  return JSON.parse(normalizedString);
};
